import React from "react";

function CoachStatCard({
  icon: Icon,
  label,
  value,
  description,
  tone = "blue",
  details,
}) {
  const toneClasses = {
    blue: "from-sky-600 to-blue-700 bg-sky-100 text-sky-700 dark:bg-sky-500/10 dark:text-sky-200",
    green:
      "from-emerald-600 to-green-700 bg-emerald-100 text-emerald-700 dark:bg-emerald-500/10 dark:text-emerald-200",
    red: "from-red-600 to-rose-700 bg-red-100 text-red-700 dark:bg-red-500/10 dark:text-red-200",
    amber:
      "from-amber-500 to-orange-600 bg-amber-100 text-amber-700 dark:bg-amber-500/10 dark:text-amber-200",
    slate:
      "from-slate-700 to-slate-900 bg-slate-100 text-slate-700 dark:bg-white/10 dark:text-white/70",
  };

  const toneClass = toneClasses[tone] || toneClasses.blue;
  const [gradientClass, badgeClass] = toneClass.split(" bg-");

  return (
    <article className="overflow-hidden rounded-[2rem] border border-slate-200 bg-white shadow-xl shadow-slate-200/60 dark:border-white/10 dark:bg-slate-900 dark:shadow-black/20">
      <div className={`h-2 bg-gradient-to-r ${gradientClass}`} />

      <div className="p-5">
        <div className="flex items-start justify-between gap-4">
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.14em] text-slate-400">
              {label}
            </p>

            <p className="mt-3 font-titre text-4xl font-bold text-slate-950 dark:text-white">
              {value}
            </p>
          </div>

          {Icon && (
            <div className={`flex h-12 w-12 items-center justify-center rounded-2xl bg-${badgeClass}`}>
              <Icon />
            </div>
          )}
        </div>

        {details && (
          <div className="mt-4 flex flex-wrap gap-2">
            {details.map((item) => (
              <span
                key={item.label}
                className="rounded-full bg-slate-100 px-3 py-1 text-xs font-bold text-slate-600 dark:bg-white/10 dark:text-white/60"
              >
                {item.label} : {item.value}
              </span>
            ))}
          </div>
        )}

        {description && (
          <p className="mt-4 text-sm font-medium leading-6 text-slate-500 dark:text-white/50">
            {description}
          </p>
        )}
      </div>
    </article>
  );
}

export default CoachStatCard;